import { useMemo } from 'react';
import './style.css';
import { Block } from '../../../../crRender';
import { generator } from '@/utils/NumbersUtils'

export const TableSkeleton = ({ isLoading }) => {
  const columns = useMemo(() => Array(5).fill('Column'), []);
  const rows = useMemo(() => Array(6).fill('Column'), []);

  return (<>
    <Block isRender={isLoading} className="table-container  skeleton-background-table">
    <div className="skeleton-cell pagging"></div>
      <table className="scrollable-table">
        {/* Table Header */}
        <thead className="table-header">
          <tr>
            {columns.mapWithKey((_, index) => (
              <th key={_.key} >
                <div className="skeleton-header"></div>
              </th>
            ))}
          </tr>
        </thead>

        {/* Table Body */}
        <tbody className="table-body">
          {rows.mapWithKey((_, index) => (
            <tr key={_.key} >
              {columns.mapWithKey((_, index) => (
                <td key={_.key} >
                  <div className="skeleton-cell"></div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </Block>
  </>
  );
};